
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/genericPage",
      function () {
        return require("private-next-pages/genericPage/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/genericPage"])
      });
    }
  